export default __webpack_public_path__ + "static/media/Janca.9b05cb25.png";